module.exports = __webpack_public_path__ + "img/pic-23.704d4b72.png";